<template>
  <div
    class="flex items-center col-12"
    :class="{ 'semaine-nav grey-bg': !scheduled }"
  >
    <div class="h5 center col-12" :class="{ py2: !scheduled }">
      <div class="flex col-12 full-height">
        <div class="flex justify-start items-center">
          <button
            class="btn btn-inverted p1 full-height"
            :class="{ disabled: isDaily ? !dayOffset : !weekOffset}"
            @click="goBack()"
          >
            <i class="icon icon-angle-left-icon bold"></i>
          </button>
        </div>
        <DatePicker
          ref="picker"
          v-model="calendar_date"
          class="flex col-12"
          mode="date"
          :min-date="min_date"
          :max-date="max_date"
          color="purple"
          :attributes="isDaily ? [] : attrs"
          :first-day-of-week="scheduled ? 2 : null"
        >
          <template #default="{ togglePopover }">
            <div
              class="
                flex
                items-center
                p1
                relative
                white-bg
                flex-grow
                bold
                align-middle
                date-label
                mx1
              "
              :class="{ 'border grey-bg': !scheduled }"
              @click="togglePopover()"
            >
              <div
                class="col-12 bold align-middle xs-hide"
              >
                {{ label.big }}
              </div>
              <div
                class="col-12 bold align-middle sm-hide md-hide lg-hide"
              >
                {{ label.small }}
              </div>
            </div>
          </template>
        </DatePicker>

        <div class="flex justify-end items-center">
          <button
            class="btn btn-inverted p1 full-height"
            :class="{ disabled: (isDaily ? dayOffset : weekOffset) + 1 > (isDaily ? max_days : max_weeks) }"
            @click="goForward()"
          >
            <i class="icon icon-angle-right-icon bold"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref, watch, inject } from 'vue';
import {
  addMonths,
  differenceInWeeks,
  differenceInDays,
  addDays,
  format,
  parseISO,
  addWeeks,
  sub,
  add,
  startOfDay,
  startOfWeek,
  endOfWeek
} from 'date-fns';
import 'v-calendar/dist/style.css';
import { DatePicker } from 'v-calendar';

export default {
  components: { DatePicker },
  props: {
    label: {
      type: Object,
      default: () => {}
    },
    time: {
      type: Number,
      default: 0
    },
    change: {
      type: Function,
      default: () => {}
    },
    scheduled: {
      type: Boolean,
      default: false
    },
    isDaily: {
      type: Boolean,
      default: false
    },
    id: { type: String },
  },
  setup (props) {
    const store = useStore();

    const showModal = inject('showModal');
    const modalMessage = inject('modalMessage');
    const successModal = inject('successModal');

    const calculateDayOffset = day => differenceInDays(day, startOfDay(new Date()));
    const calculateWeekOffset = day => differenceInWeeks(startOfWeek(day, { weekStartsOn: 1 }), startOfWeek(new Date(), { weekStartsOn: 1 }));
    const calendarDay = computed(() => {
      const date = store.getters.calendarDay(props.id);
      if (!date) {
        return parseISO(format(startOfDay(new Date()), 'yyyy-MM-dd'));
      }
      return parseISO(format(add(startOfDay(new Date(date)), { hours: 1 }), 'yyyy-MM-dd'));
    });
    //  const weekOffset = computed(() => (props.scheduled ? differenceInWeeks(startOfWeek(calendarDay.value, { weekStartsOn: 1 }), startOfWeek(new Date(), { weekStartsOn: 1 })) : differenceInWeeks(calendarDay.value, startOfDay(new Date()))));
    const weekOffset = computed(() => calculateWeekOffset(calendarDay.value));
    const dayOffset = computed(() => calculateDayOffset(calendarDay.value));

    const calendar_date = ref(calendarDay.value);
    // const startOfCurrentWeek = ref(props.scheduled ? startOfWeek(calendarDay.value, { weekStartsOn: 1 }) : addWeeks(startOfDay(new Date()), weekOffset.value));
    // const endOfCurrentWeek = ref(props.scheduled ? endOfWeek(calendarDay.value, { weekStartsOn: 1 }) : sub(addWeeks(startOfDay(new Date()), weekOffset.value + 1), { days: 1 }));
    const startOfCurrentWeek = ref(weekOffset.value ? startOfWeek(calendarDay.value, { weekStartsOn: 1 }) : props.isDaily ? calendarDay.value : new Date());
    const endOfCurrentWeek = ref(endOfWeek(calendarDay.value, { weekStartsOn: 1 }));
    const attrs = ref([
      {
        highlight: 'blue',
        dates: {
          start: startOfCurrentWeek.value,
          end: endOfCurrentWeek.value
        }
      }]);
    const calendarMonths = computed(() => store.state.siteInfo.tda_settings.calendarMonths);
    const weeksReserveLimit = computed(() => store.state.siteInfo.perso_settings.plannerWeeksToShow);
    const max_weeks = computed(() => differenceInWeeks(
      addMonths(startOfDay(new Date()), calendarMonths.value),
      startOfDay(new Date())
    ));
    const max_days = computed(() => differenceInDays(
      addMonths(startOfDay(new Date()), calendarMonths.value),
      startOfDay(new Date())
    ));
    const min_date = computed(() => format(startOfDay(new Date()), 'yyyy-MM-dd'));
    // const max_date = computed(() => format(addMonths(startOfDay(new Date()), calendarMonths.value),'yyyy-MM-dd'));
    const max_date = computed(() => format(endOfWeek(addWeeks(startOfDay(new Date()), weeksReserveLimit.value)),'yyyy-MM-dd'));

    const weekDiff = computed(() => {
      if(props.isDaily){
        return differenceInDays(endOfWeek(addWeeks(new Date(), weeksReserveLimit.value)), new Date()) < dayOffset.value ;
      }
      return weekOffset.value >= weeksReserveLimit.value;
    });

    const goBack = () => {
      const cDay = {
        uid: props.id,
        date: props.isDaily ? sub(startOfDay(calendarDay.value), { days: 1 }) : weekOffset.value > 1 ? sub(startOfCurrentWeek.value, { weeks: 1 }) : startOfDay(new Date())
      };
      store.commit('addCalendarDay', cDay);
      const start = format(add(cDay.date, { hours: 1 }), 'yyyy-MM-dd');
      const startInDate = parseISO(start);
      const end = format(props.isDaily ? add(startInDate, { days: 1 }) : endOfWeek(startInDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');
      props.change(start, end);
    };
    const goForward = () => {
      if(weekDiff.value){
        successModal.value = false;
        modalMessage.value = "Les prochains créneaux ne sont pas encore disponibles."
        showModal.value = true;
        return;
      }
      const cDay = {
        uid: props.id,
        date: props.isDaily ? addDays(startOfDay(calendarDay.value), 1) : startOfWeek(addWeeks(startOfCurrentWeek.value, 1), { weekStartsOn: 1 })
      };

      store.commit('addCalendarDay', cDay);

      const start = format(add(cDay.date, { hours: 1 }), 'yyyy-MM-dd');
      const startInDate = parseISO(start);
      const end = format(props.isDaily ? add(startInDate, { days: 1 }) : endOfWeek(startInDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');

      props.change(start, end);
    };
    watch(calendar_date, (newValue, oldValue) => {
      const cDay = {
        uid: props.id,
        date: newValue
      };
      store.commit('addCalendarDay', cDay);
      const newDate = parseISO(format(startOfDay(new Date(newValue)), 'yyyy-MM-dd'));
      const oldDate = parseISO(format(startOfDay(new Date(oldValue)), 'yyyy-MM-dd'));
      const newTime = props.isDaily
        ? differenceInDays(newDate, startOfDay(new Date()))
        : differenceInWeeks(startOfWeek(newDate), startOfWeek(new Date()));
      const oldTime = props.isDaily
        ? differenceInDays(oldDate, startOfDay(new Date()))
        : differenceInWeeks(startOfWeek(oldDate), startOfWeek(new Date()));

      if (newTime !== oldTime) {
        const start = props.isDaily || !calculateWeekOffset(cDay.date) ? format(add(props.isDaily ? cDay.date : new Date(), { hours: 1 }), 'yyyy-MM-dd') : format(startOfWeek(cDay.date, { weekStartsOn: 1 }), 'yyyy-MM-dd');
        const startInDate = parseISO(start);
        const end = format(props.isDaily ? add(startInDate, { days: 1 }) : endOfWeek(startInDate, { weekStartsOn: 1 }), 'yyyy-MM-dd');
        props.change(start, end);
      }
    });

    return {
      weekDiff,
      max_weeks,
      max_days,
      min_date,
      max_date,
      calendar_date,
      calendarDay,
      attrs,
      weekOffset,
      dayOffset,
      goBack,
      goForward
    };
  }
};
</script>

<style lang="scss" scoped>
.semaine-nav {
  min-height: 75px;
}

.date-picker {
  z-index: 15;
  transform: translate(99999px, 99999px);
}

.border {
  border: 1px solid black;
}

.date-label {
  min-width: 100px;
  transition: 0.3s ease-in all;
  cursor: pointer;
  box-sizing: border-box;
}

.date-label:hover {
  background-color: #0f1f28;
  color: #fff;
}
</style>
